import React from "react";
import { Link } from "react-router-dom";
import { Construction, PlusCircle } from "lucide-react";
import { MKT_GOLD, MKT_TINT } from "../../lib/marketplace";

export default function SeccionPlaceholder({ titulo, descripcion, testid }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-soft p-10 text-center" data-testid={testid || "mkt-placeholder"}>
      <span className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center" style={{ backgroundColor: MKT_TINT, color: MKT_GOLD }}>
        <Construction size={26} />
      </span>
      <h2 className="mt-4 text-lg font-bold text-slate-900">{titulo}</h2>
      <p className="mt-1 text-sm text-slate-500 max-w-md mx-auto">{descripcion}</p>
      <span className="mt-4 inline-block text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-3 py-1">
        Sección en vista previa · disponible próximamente
      </span>
      <div className="mt-6">
        <Link
          to="/marketplace/crear-tienda"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-white font-bold shadow-sm hover:brightness-110 transition-all"
          style={{ backgroundColor: MKT_GOLD }}
        >
          <PlusCircle size={16} /> Crear mi tienda
        </Link>
      </div>
    </div>
  );
}
